import React from "react";
import '../styles/components/AboutMeComponent.css'

const AboutMeComponent = () => {

    return (
        <>
            <div className='about-me-component'>
                <div className='caption'>
                    <h1>بلال التركي</h1>
                    <h2>مديـر أعمـــــال</h2>
                    <p>لوريم ايبسوم دولار سيت أميت ,كونسيكتيتور أدايبا بلط ليايت,سيت دو أيوسمود تيمبور أنكايديديونتيوت لابوري ات دولار ماجنا أليكيوا .</p>
                </div>
                <div className="businessman"></div>
            </div>
        </>
    )

}

export default AboutMeComponent